"use strict";

import React from "react";
import ReactDOM from "react-dom";
import classnames from "classnames";

import lang from "vwa/lang";
import Button from "vwa/components/Button";
import Dialog from "vwa/components/Dialog";
import Select from "vwa/components/Select";
import Form from "vwa/components/Form";
import MultiSelector from "vwa/components/MultiSelector";
import Checkbox from "vwa/components/Checkbox";

import {isValidNotificationConfig, isValidEventDescriptor} from "./../../../utils/notification";

import CriticalValueNotificationConfigForm from "./../CriticalValueNotificationConfigForm";

export default class AddDialog extends React.Component {
	
	constructor(props){
		super(props);
		this.initState();
	}
	
	initState(){
		this.state = {
			eventDescriptor: null,
			notificationConfig: null	
		};
	}
	
	componentDidMount(){
		this.setState({
			eventDescriptor: this.refs.criticalValueNotificationConfigForm.getEventDescriptor(),
			notificationConfig: this.refs.criticalValueNotificationConfigForm.getNotificationConfig()
		});
	}
	
	clear(){
		this.refs.criticalValueNotificationConfigForm.clear();
	}
	
	handleCancel(){
		this.refs.criticalValueNotificationConfigForm.clear();
		this.props.onCancel();
	}
	
	getSaveButtonDisabled(){
		return !isValidNotificationConfig(this.state.notificationConfig) || !isValidEventDescriptor(this.state.eventDescriptor);
	}
	
	render(){
		return(
			<Dialog shown={this.props.shown} className="AddDialog">
				<header><h1>{lang.SET_NOTIFICATION}</h1></header>
				<CriticalValueNotificationConfigForm
					ref="criticalValueNotificationConfigForm"
					dataTypes={this.props.dataTypes}
					vehicles={this.props.vehicles}
					onChange={(eventDescriptor, notificationConfig) => this.setState({eventDescriptor, notificationConfig})}
				/>
				<footer>
					<Button onClick={() => this.handleCancel()}>{lang.CANCEL}</Button>
					<Button disabled={this.getSaveButtonDisabled()} onClick={() => this.props.onAdd(this.state.eventDescriptor, this.state.notificationConfig)} className="Red">{lang.SAVE}</Button>
				</footer>
			</Dialog>
		);
	}
	
}

AddDialog.propTypes = {
	shown: 		React.PropTypes.bool,
	onCancel:	React.PropTypes.func,
	onAdd:		React.PropTypes.func,
	dataTypes: 	React.PropTypes.array,
	vehicles:	React.PropTypes.array
};

AddDialog.defaultProps = {
	shown: 		false,
	onCancel:	() => {},
	onAdd:		(eventDescriptor, notificationConfig) => {},
	dataTypes: 	[],
	vehicles: 	[]
};


// WEBPACK FOOTER //
// ./src/view/CriticalValueNotifications/AddDialog/AddDialog.jsx